import React from "react";

import {
  AppViewerDrawer,
  AppViewerDrawerSection,
  AppViewerDrawerSectionContent,
  AppViewerDrawerSectionTitle,
} from "Components/Generic/AppViewerDrawer";

import { DiaryType } from "../../../../../../components/DiaryCalendar";
import { Button } from "../../../../../../components/Form";
import { Color } from "../../../../../../components/Form/Button";
import { SeeTaskContent } from "../TaskContent";
import { DiarySeeManyProps } from "../types";
import useStyles from "./styles";
import { useAppState } from "Context/StateContext";

export const DiarySeeManyTaskDrawer: React.FC<DiarySeeManyProps> = ({
  tasks,
  daySelected,
  viewMode,
  onCloseModal,
  onChangeToOneTask,
  isOpen,
}) => {
  const classes = useStyles();
  const { formatWithUserTimezone } = useAppState();

  const renderTitleTextByViewMode = () => {
    if (daySelected && viewMode) {
      switch (viewMode) {
        case DiaryType.WEEK:
          return formatWithUserTimezone(daySelected, "EEEE dd, ha");
        case DiaryType.DAY:
          return formatWithUserTimezone(daySelected, "EEEE dd, ha");
        case DiaryType.MONTH:
        default:
          return formatWithUserTimezone(daySelected, "EEEE, dd LLLL");
      }
    }
  };

  const renderContent = () =>
    tasks.map((task) => (
      <AppViewerDrawerSection key={task.id}>
        <AppViewerDrawerSectionTitle>
          <span className={classes.wrapperTitle}>{task?.type}</span>

          <Button
            customColor={Color.BRAND_OUTLINED}
            onClick={() => onChangeToOneTask(task)}
            style={{ marginLeft: "auto" }}
          >
            {"See task individually"}
          </Button>
        </AppViewerDrawerSectionTitle>

        <AppViewerDrawerSectionContent
          data-cy="seemore-content"
          disableGutters
          disableMinHeight
          sx={{ paddingTop: "32px", paddingBottom: "24px" }}
        >
          <SeeTaskContent task={task} />
        </AppViewerDrawerSectionContent>
      </AppViewerDrawerSection>
    ));

  return (
    <AppViewerDrawer
      DrawerProps={{
        open: isOpen,
        onClose: onCloseModal,
      }}
      title={renderTitleTextByViewMode()}
    >
      {renderContent()}
    </AppViewerDrawer>
  );
};
